import React from 'react';
import { X, RotateCcw } from 'lucide-react';
import '../styles/ActiveFiltersBar.css';
import * as FeatherIcon from 'react-feather';


const ActiveFiltersBar = ({
    selectedCompanies = [],
    selectedNewsTypes = [],
    selectedRegions = [],
    selectedIndustryNewsDomains = [],
    selectedCustomerDomains = [],
    searchQuery = '',
    companyNames = {},
    newsTypesMap = {},
    regionsMap = {},
    domainNames = {},
    onlyWithTimeline = false,
    onRemoveFilter,
    onResetAll
}) => {
    // Calculate total active filters
    const totalFilters = selectedCompanies.length +
        selectedNewsTypes.length +
        selectedRegions.length +
        selectedIndustryNewsDomains.length +
        selectedCustomerDomains.length +
        (searchQuery ? 1 : 0) +
        (onlyWithTimeline ? 1 : 0);

    // Don't render if no filters are active
    if (totalFilters === 0) {
        return null;
    }

    return (
        <div className="active-filters-bar-news">
            <div className="active-filters-header-news">
                <span className="active-filters-title-news">
                    Active Filters <span className="filter-count-news">({totalFilters})</span>
                </span>
                <button className="reset-all-button-news" onClick={onResetAll}>
                    <RotateCcw size={14} />
                    Reset All
                </button>
            </div>

            <div className="filter-chips-container-news">
                {/* Search Query Chip */}
                {searchQuery && (
                    <div className="filter-chip-news filter-chip-search-news">
                        <span className="chip-label-news">Search:</span>
                        <span className="chip-value-news">{searchQuery}</span>
                        <button
                            className="chip-remove-news"
                            onClick={() => onRemoveFilter('search', searchQuery)}
                            aria-label="Remove search filter"
                        >
                            <FeatherIcon.XCircle className='icons_table ' />
                        </button>
                    </div>
                )}

                {/* Company Chips */}
                {selectedCompanies.map(companyCode => (
                    <div key={`company-${companyCode}`} className="filter-chip-news filter-chip-company-news">
                        <span className="chip-label-news">Company:</span>
                        <span className="chip-value-news">{companyNames[companyCode] || companyCode}</span>
                        <button
                            className="chip-remove-news"
                            onClick={() => onRemoveFilter('company', companyCode)}
                            aria-label={`Remove ${companyNames[companyCode] || companyCode} filter`}
                        >
                            <FeatherIcon.XCircle className='icons_table ' />
                        </button>
                    </div>
                ))}

                {/* Industry News Chips */}
                {selectedIndustryNewsDomains.map(domainValue => (
                    <div key={`industrynews-${domainValue}`} className="filter-chip-news filter-chip-newstype-news">
                        <span className="chip-label-news">Industry News:</span>
                        <span className="chip-value-news">{domainNames[domainValue] || domainValue}</span>
                        <button
                            className="chip-remove-news"
                            onClick={() => onRemoveFilter('industryNewsTrend', domainValue)}
                            aria-label={`Remove ${domainNames[domainValue] || domainValue} filter`}
                        >
                            <FeatherIcon.XCircle className='icons_table ' />
                        </button>
                    </div>
                ))}

                {/* Customer Industry Chips */}
                {selectedCustomerDomains.map(domainValue => (
                    <div key={`customerind-${domainValue}`} className="filter-chip-news filter-chip-region-news">
                        <span className="chip-label-news">Customer Industry:</span>
                        <span className="chip-value-news">{domainNames[domainValue] || domainValue}</span>
                        <button
                            className="chip-remove-news"
                            onClick={() => onRemoveFilter('industryTrend', domainValue)}
                            aria-label={`Remove ${domainNames[domainValue] || domainValue} filter`}
                        >
                            <FeatherIcon.XCircle className='icons_table ' />
                        </button>
                    </div>
                ))}

                {/* News Type Chips */}
                {selectedNewsTypes.map(newsType => (
                    <div key={`newstype-${newsType}`} className="filter-chip-news filter-chip-newstype-news">
                        <span className="chip-label-news">News Type:</span>
                        <span className="chip-value-news">{newsTypesMap[newsType] || newsType}</span>
                        <button
                            className="chip-remove-news"
                            onClick={() => onRemoveFilter('newsType', newsType)}
                            aria-label={`Remove ${newsTypesMap[newsType] || newsType} filter`}
                        >
                            <FeatherIcon.XCircle className='icons_table ' />
                        </button>
                    </div>
                ))}

                {/* Region Chips */}
                {selectedRegions.map(region => (
                    <div key={`region-${region}`} className="filter-chip-news filter-chip-region-news">
                        <span className="chip-label-news">Region:</span>
                        <span className="chip-value-news">{regionsMap[region] || region}</span>
                        <button
                            className="chip-remove-news"
                            onClick={() => onRemoveFilter('region', region)}
                            aria-label={`Remove ${regionsMap[region] || region} filter`}
                        >
                            <FeatherIcon.XCircle className='icons_table ' />
                        </button>
                    </div>
                ))}

                {/* Timeline Chip */}
                {onlyWithTimeline && (
                    <div className="filter-chip-news filter-chip-newstype-news">
                        <span className="chip-label-news">Highlight:</span>
                        <span className="chip-value-news">News with Timelines</span>
                        <button
                            className="chip-remove-news"
                            onClick={() => onRemoveFilter('timeline')}
                            aria-label="Remove timeline filter"
                        >
                            <FeatherIcon.XCircle className='icons_table ' />
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ActiveFiltersBar;
